module.exports = __webpack_public_path__ + "img/Group_28366@2x.69cf179c.png";